import React, {Component} from 'react'
import ComparisonList from '../ComparisonList/ComparisonList'
import styles from './modal.module.scss'
import Api from '../../../../core/api/Api'

const ModalList = ({children, closeModal, compareCards}) => (
   <div id={styles.modal}>
      <div className={styles.modal}>
         <svg className={styles.modal__cross} onClick={closeModal} width='12' height='12' viewBox='0 0 12 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
            <path opacity='0.5'
                  d='M0.409605 0.41107C0.735042 0.0856329 1.26268 0.0856329 1.58812 0.41107L5.99886 4.82181L10.4096 0.41107C10.735 0.0856329 11.2627 0.0856329 11.5881 0.41107C11.9136 0.736507 11.9136 1.26414 11.5881 1.58958L7.17737 6.00033L11.5881 10.4111C11.9136 10.7365 11.9136 11.2641 11.5881 11.5896C11.2627 11.915 10.735 11.915 10.4096 11.5896L5.99886 7.17884L1.58812 11.5896C1.26268 11.915 0.735042 11.915 0.409605 11.5896C0.0841681 11.2641 0.0841681 10.7365 0.409605 10.4111L4.82035 6.00033L0.409605 1.58958C0.0841681 1.26414 0.0841681 0.736507 0.409605 0.41107Z'
                  fill='#3F454D' />
         </svg>
         <h2 className={styles.modal__title}>Comparison of Dating sites</h2>
         <span className={styles.modal__sub}>You can compare no more than 3 websites</span>
         {children}
         <div className={styles.modal__compareBlock}>
            <button className={styles.modal__compareBtn} onClick={compareCards}>Compare</button>
         </div>
      </div>
   </div>
)

class Modal extends Component {
   state = {
      cards: [],
      isActive: [],
      newCards: [],
   }
   handleChoice = (e) => {
      this.setState({
         isActive: [...this.state.isActive, e.currentTarget.id],
      })
   }

   sendCards = () => {
      const {newCards, isActive, cards} = this.state
      isActive.length > 0 && isActive.map(el => {
         cards.map(e => {
            el === e.id.toString() ? newCards.push(e) : null
            newCards.length >= 5 && newCards.splice(2, 1)
            localStorage.setItem('newCards',
               JSON.stringify(newCards.filter((el, id) => newCards.indexOf(el) === id)))
         })
      })
   }

   componentDidMount() {
      Api.requestCompareAllData()
         .then(data => {
            if (data.success) {
               this.setState({cards: data.data})
            }
            console.log('Api.requestCompareAllData():', data)
         })
         .catch(console.error)

      // fetch('/comparison.json')
      //    .then(response => {
      //       // console.log(response)
      //       return response.json()
      //    })
      //    .then(data => {
      //       console.log(data)
      //       this.setState({cards: data})
      //    })
   }

   componentDidUpdate() {
      this.sendCards()
   }

   componentWillUnmount() {
      this.props.closeModal()
   }

   render() {
      const {cards, isActive, newCards} = this.state
      isActive.length >= 4 && isActive.splice(2, 1)
      return (
         <ModalList closeModal={this.props.closeModal} compareCards={this.props.compareCards} isActive={isActive}>
            {newCards !== [] && <ComparisonList persons={cards} isActive={isActive} onClick={this.handleChoice} />}
         </ModalList>
      )
   }
}

export default Modal